import { RouteObject } from 'react-router-dom';
import { OverviewPage } from '@/modules/overview/OverviewPage';
import { AICommandPage } from '@/modules/aicommand/AICommandPage';
import { AIOperationsPage } from '@/modules/aioperations/AIOperationsPage';
import { CreatorsPage } from '@/modules/creators/CreatorsPage';
import { CreatorDetailPage } from '@/modules/creators/CreatorDetailPage';
import { FollowUpsPage } from '@/modules/followups/FollowUpsPage';
import { ApprovalsPage } from '@/modules/approvals/ApprovalsPage';
import { PartnershipsPage } from '@/modules/partnerships/PartnershipsPage';
import { PartnershipDetailPage } from '@/modules/partnerships/PartnershipDetailPage';
import { ContractsPage } from '@/modules/contracts/ContractsPage';
import { AgentsPage } from '@/modules/agents/AgentsPage';
import { ConnectorsPage } from '@/modules/connectors/ConnectorsPage';
import { ActivityPage } from '@/modules/activity/ActivityPage';
import { SystemPage } from '@/modules/system/SystemPage';
import { SupportPage } from '@/modules/support/SupportPage';
import { AIModelsPage } from '@/modules/aimodels/AIModelsPage';
import { AutomationsPage } from '@/modules/automations/AutomationsPage';
import { MemoryPage } from '@/modules/memory/MemoryPage';
import { AgentLogPage } from '@/modules/agentlog/AgentLogPage';
import { SettingsPage } from '@/modules/settings/SettingsPage';
import { ComingSoonPage } from '@/modules/comingsoon/ComingSoonPage';

/**
 * Routes are built from a small map keyed by module id — the SAME ids
 * used in modules.config.ts. Every "live" module in MODULES now has a
 * matching route here (previously agents/activity/connectors/system/
 * settings were config-only with no page — that gap is closed). Adding a
 * fully custom module page later means adding one entry here; it never
 * means restructuring this file.
 *
 * All 9 live modules + 2 detail routes below are real client-side routes
 * (react-router's useRoutes), not static file:// pages — a hard refresh
 * on /creators/UGC-0027 works once Nginx falls back unmatched paths to
 * index.html (see infra/nginx-command-center.conf, updated for this).
 */
export const routes: RouteObject[] = [
  { path: '/', element: <OverviewPage /> },
  { path: '/ai-command', element: <AICommandPage /> },
  { path: '/ai-operations', element: <AIOperationsPage /> },
  { path: '/creators', element: <CreatorsPage /> },
  { path: '/creators/:id', element: <CreatorDetailPage /> },
  { path: '/followups', element: <FollowUpsPage /> },
  { path: '/approvals', element: <ApprovalsPage /> },
  { path: '/partnerships', element: <PartnershipsPage /> },
  { path: '/partnerships/:id', element: <PartnershipDetailPage /> },
  { path: '/contracts', element: <ContractsPage /> },
  { path: '/agents', element: <AgentsPage /> },
  { path: '/activity', element: <ActivityPage /> },
  { path: '/connectors', element: <ConnectorsPage /> },
  { path: '/system', element: <SystemPage /> },
  { path: '/support', element: <SupportPage /> },
  { path: '/ai-models', element: <AIModelsPage /> },
  { path: '/automations', element: <AutomationsPage /> },
  { path: '/memory', element: <MemoryPage /> },
  { path: '/agent-log', element: <AgentLogPage /> },
  { path: '/settings', element: <SettingsPage /> },
  { path: '/content', element: <ComingSoonPage /> },
  { path: '/crm', element: <ComingSoonPage /> },
  { path: '/social', element: <ComingSoonPage /> },
  { path: '/ads', element: <ComingSoonPage /> },
  { path: '/clients', element: <ComingSoonPage /> },
  { path: '/projects', element: <ComingSoonPage /> },
  { path: '/finance', element: <ComingSoonPage /> },
];
